export default __webpack_public_path__ + "static/media/keto_pro@2x.121abb9c.jpg";